import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';



export const FILES_ENDPOINT = 'file';
export const FILES_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(FILES_ENDPOINT);


export const fileStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
